import { connect } from 'react-redux';

import { confirmWarning, closeWarning } from '../actions/cancelOrderChangesWarning';

import CancelOrderChangesWarning from '../components/CancelOrderChangesWarning';

export default connect(
  state => ({
    visible: state.header.cancelOrderChangesWarning.warningVisible,
  }), {
    onWarningConfirmed: confirmWarning,
    onWarningClosed: closeWarning,
  }
)(CancelOrderChangesWarning);
